<template>
  <main class="col bg-faded py-3 p-5 m-5">
    <app-edit
      :table="table"
      :field="field"
      :tableInfo="tableInfo"
      :nametable="nametable"
      :showForm="showForm"
    ></app-edit>
  </main>
</template>

<script>
import ApiService from "@/common/api.service";

import editbread from "@/components/Dashboard/forms/editbread";

export default {
  name: "BreadEdit",
  components: {
    "app-edit": editbread,
  },
  async created() {
    await this.getTable();
    if (this.$route.name === "Dashboard formulario editar") {
      this.update = true;
      this.insert = false;
      await this.getEditTable();
      await this.getInfoBread();
    } else if (this.$route.name === "Dashboard formulario nuevo") {
      this.update = false;
      this.insert = true;
      this.showForm = true;
      await this.getEditTable();
    } else {
      this.update = false;
      this.insert = false;
    }
    this.$on("parentSave", () => {
      this.save();
    });
  },
  data() {
    return {
      nametable: this.$route.params.table,
      table: {},
      field: {},
      tableInfo: {},
      showForm: false,
      tipe: false,
      insert: false,
      update: false,
    };
  },
  methods: {
    async getTable() {
      let response = await ApiService.post("dashboard/tablecolumns", {
        table: this.$route.params.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      this.table = response.data;
    },
    async getEditTable() {
      let response = await ApiService.post("dashboard/getbread", {
        table: this.$route.params.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      if (response.data) {
        this.field = response.data;
      } else {
        let data = [];
        data.push(this.nametable);
        this.table.forEach((e) => {
          let item = {
            field: e.Field,
            visibility: {
              thead: true,
              edit: true,
            },
            type: e.Type,
            name: e.Field,
            options: [],
          };
          data.push(item);
        });
        this.field = { data };
      }
    },
    async getInfoBread() {
      ApiService.post("dashboard/getinfobread", {
        table: this.$route.params.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      }).then((response) => {
        this.tableInfo = response.data;
        this.showForm = true;
      });
    },
    save() {
      let data = [];
      data.push(this.nametable);

      for (let index = 0; index < this.table.length; index++) {
        let a = JSON.parse(
          "[" +
            document.querySelector('textarea[name="field_options_' + index + '"]').value +
            "]"
        );
        let item = {
          field: this.table[index].Field,
          visibility: {
            thead: document.querySelector('input[name="field_thead_' + index + '"]')
              .checked,
            edit: document.querySelector('input[name="field_edit_' + index + '"]')
              .checked,
          },
          type: document.querySelector('select[name="input_type_' + index + '"]').value,
          name: document.querySelector('input[name="display_name_' + index + '"]').value,
          options: a,
        };
        data.push(item);
      }

      let params = {
        breadInfo: this.tableInfo,
        data: data,
      };

      let action = {
        icon: "fa-times-circle",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      };

      let tipe;
      this.insert ? (tipe = "insert") : (tipe = "update");

      ApiService.post("dashboard/savebread", {
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        params: params,
        tipe: tipe,
      })
        .then((response) => {
          this.msg("Registro actualizado", "success", action);
          setTimeout(() => {
            this.$router.replace(
              this.$route.query.redirect || { name: "Dashboard-formularios" }
            );
          }, 1000);
        })
        .catch((error) => {
          this.msg(data.error, "error", action);
        });
    },
    msg(msg, type, action = null) {
      this.$notify({
        title: msg,
        position: "bottom-right",
        type: type,
        duration: 5000,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Bread.vue